module.exports = __webpack_public_path__ + "img/solid-pod-access-corp.1b51f781.png";